var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('van-button',{attrs:{"type":"default","to":"/login"}},[_vm._v("登录页")]),_vm._v(" "),_c('van-button',{attrs:{"type":"default"},on:{"click":_vm.doPost}},[_vm._v("doGet")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bda8f6d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/index.vue
// module id = null
// module chunks = 